import { Typography } from '@material-ui/core';
import { format, parseISO } from 'date-fns';
import { getVacancyIndexStatus } from 'lib/Api/SimilarCandidates';
import * as React from 'react';

// "vacancies last synced ..." under the header
export const VacancySyncNote: React.FC = () => {
  const [syncedAt, setSyncedAt] = React.useState<string | null>(null);

  React.useEffect(() => {
    let cancelled = false;
    getVacancyIndexStatus()
      .then((status) => {
        if (cancelled || !status.last_synced_at) return;
        // the api sends utc, parseISO turns it into the recruiter's local time
        setSyncedAt(
          format(parseISO(status.last_synced_at), 'd MMMM yyyy, HH:mm'),
        );
      })
      // just a hint, so no error if it fails
      .catch(() => undefined);
    return () => {
      cancelled = true;
    };
  }, []);

  if (!syncedAt) return null;
  return (
    <Typography
      variant="caption"
      color="textSecondary"
      component="div"
      style={{ marginTop: 4 }}
    >
      Vacancies last synced {syncedAt}.
    </Typography>
  );
};
